import { productInformationStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import { css } from "styled-components";

// productInformationStyles.descriptionStyles = {
//     productDetailLink: {
//         css: css`
//             width: 100%;
//         `,
//         typographyProps: {
//             size: 20,
//             weight: 700,
//         },
//     },
// };

// productInformationStyles.brandStyles = {
//     nameText: {
//         weight: 700,
//     },
//     nameLink: {
//         typographyProps: {
//             weight: 700,
//         },
//     },
// };

productInformationStyles.partNumbersStyles = {
    erpNumberLabelText: {
        css: css`
        margin-right: 15px;`,
        weight: "normal",
    },
    customerNameLabelText: {
        css: css``,
        weight: "normal",
    },
    manufacturerItemLabelText: {
        css: css`
        margin-right: 15px;`,
        weight: "normal",
    },
};
